import { History } from "lucide-react";

const TONE = { added: "text-emerald-700", removed: "text-red-600 line-through", changed: "text-amber-700" };
const LABEL = { added: "+ Tambah", removed: "− Hapus", changed: "~ Ubah" };

export const RevisionHistory = ({ history = [] }) => (
  <div className="border border-border bg-card rounded-sm" data-testid="revision-history">
    <div className="px-6 py-4 border-b border-border overline text-muted-foreground flex items-center gap-2">
      <History className="w-4 h-4" /> Riwayat Revisi
    </div>
    <div className="p-6 space-y-4 max-h-96 overflow-y-auto">
      {history.length === 0 && <p className="text-sm text-muted-foreground">Belum ada revisi tercatat.</p>}
      {[...history].reverse().map((h) => (
        <div key={h.rev} className="border-l-2 border-primary/40 pl-4" data-testid={`revision-rev-${h.rev}`}>
          <div className="flex flex-wrap items-baseline gap-x-3 text-sm">
            <span className="font-mono font-semibold">Rev{String(h.rev).padStart(2, "0")}</span>
            <span className="text-xs text-muted-foreground">{new Date(h.at).toLocaleString("id-ID")} · {h.by} · {h.source}</span>
          </div>
          <ul className="mt-1 space-y-0.5 text-xs">
            {(h.changes || []).length === 0 && <li className="text-muted-foreground">Tidak ada perubahan item</li>}
            {(h.changes || []).map((c, i) => (
              <li key={i} className={TONE[c.type]}>
                <span className="font-semibold">{LABEL[c.type]}</span> {c.product}{c.detail ? ` — ${c.detail}` : ""}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </div>
);
